import axiosInstance from "../../../services/axiosInstance";


export const storeAddress = async (request = {}) => {
    const response = await axiosInstance.post('addresses',  request );
    return response.data;
};
export const getAddresses = async (params = null) => {
    const response = await axiosInstance.get('addresses', {params} );
    return response.data;
};
export const deleteAddress = async (id,params = null) => {
    const response = await axiosInstance.delete(`addresses/${id}`, {params} );
    return response.data;
};
export const updateAddress = async (id,params = null) => {
    const response = await axiosInstance.patch(`addresses/${id}`, {params} );
    return response.data;
};
export const getAddress = async (id,params = null) => {
    const response = await axiosInstance.get(`addresses/${id}`, {params} );
    return response.data;
};
